/* eslint-disable import/no-cycle */
import React, { useState } from 'react';
import { LoadingIndicator, Button, Checkbox } from '@components';
import { toast } from 'react-toastify';
import { ConfiguracaoPortalService } from '../../../common/services/configuracaoPortal';

export const Consentimento = ({ user, setPendenciaAtiva }) => {
  const [loading, setLoading] = useState(false);
  const [aceite, setAceite] = useState(false);

  const aceitarTermo = () => {
    const confPortalService = new ConfiguracaoPortalService();
    setLoading(true);
    confPortalService
      .GerarAceiteTermoConsentimento(user.matricula, user.token)
      .then((res) => {
        if (res.sucesso) {
          setPendenciaAtiva('');
        } else {
          toast.error('Ocorreu um erro no aceite do termo.');
        }
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div>
      {!loading ? (
        <>
          <p className="ts-24 mb-4 fw-bold text-orange text-center">
            TERMO DE CONSENTIMENTO E CIÊNCIA PARA USUÁRIO DE PLATAFORMA DIGITAL
          </p>
          <div className="div-scroll div-scroll-mobile text-justify background-grey">
            <ul className="mx-4">
              <li className="tbdescription">
                <b>Efeitos jurídicos do acesso:</b> ao utilizar a Plataforma, o
                Usuário pode realizar operações como alteração de perfil,
                modificação do valor da retirada mensal, ajuste do percentual de
                contribuição, solicitação de empréstimos e outras operações
                previdenciárias. Os cliques nos botões de aprovação e anuência
                possuem o mesmo efeito jurídico de uma assinatura, representando
                a manifestação expressa de vontade do Usuário. Dessa forma, tais
                ações podem gerar obrigações , tornando algumas operações
                irreversíveis ou irretratáveis, conforme as regras estabelecidas
                para cada serviço;
              </li>
              <li className="tbdescription">
                <b>Confidencialidade dos dados:</b> os dados fornecidos na
                Plataforma são pessoais e sigilosos, e seu acesso têm caráter
                exclusivo do Usuário. O Usuário se compromete a manter a
                confidencialidade de suas credenciais, incluindo senha e token,
                não compartilhando com terceiros;
              </li>
              <li className="tbdescription">
                <b>Segurança dos dados:</b> a disponibilização de dados
                pessoais, como e-mail e token de acesso, a terceiros, seja por
                vontade própria do Usuário ou por ações não autorizadas, pode
                comprometer a sua segurança;
              </li>
              <li className="tbdescription">
                <b>Responsabilidade pelas ações:</b> o Usuário é o único
                responsável por todas as ações realizadas em sua conta na
                Plataforma, incluindo aquelas realizadas por terceiros que
                tenham obtido acesso às suas informações de acesso, sejam elas
                autorizadas ou não. A responsabilidade por qualquer ação
                realizada na conta do Usuário, decorrente do uso indevido ou
                compartilhamento dessas credenciais, será exclusivamente do
                Usuário;
              </li>
              <li className="tbdescription">
                <b>Medidas de segurança da Plataforma:</b> a Plataforma adota
                medidas de segurança para proteger os dados pessoais dos
                usuários, visando prevenir acessos não autorizados, usos
                indevidos e divulgações não autorizadas;
              </li>
              <li className="tbdescription">
                <b>Alteração do Termo:</b> a Forluz se reserva o direito de
                modificar este Termo a qualquer momento. O Usuário será
                informado das alterações por meio dos canais de comunicação
                disponibilizados pela Plataforma. A continuidade do uso da
                Plataforma após a comunicação das alterações implica na
                aceitação dos novos termos pelo Usuário;
              </li>
              <li className="tbdescription">
                <b>Canais de atendimento:</b> em caso de dúvidas sobre este
                Termo ou sobre o tratamento de dados pessoais, o Usuário pode
                entrar em contato com a Forluz por meio dos canais de
                atendimento disponíveis;
              </li>
              <li className="tbdescription">
                <b>Dados pessoais:</b> o Usuário autoriza a compartilhar dados
                pessoais com os parceiros da Forluz para o cumprimento do
                contrato de previdência, empréstimo e, eventualmente, oferecer
                produtos e serviços que possam ser do interesse do Usuário ou
                para melhorar sua experiência como cliente.
              </li>
              <p className="tbdescription">
                Um requerimento referente ao aceite ficará disponível na Área do
                Participante, em <b>Requerimentos</b> na aba de <b>Deferidos</b>
                .
              </p>
            </ul>
          </div>

          <hr className="my-3" />

          <div className="d-flex mb-32 mt-32">
            <Checkbox
              className="mx-1"
              defaultChecked={aceite}
              onChange={() => setAceite(!aceite)}
            />
            <p className="text-muted hstack">
              Li e concordo com os termos de consentimento e ciência para o uso
              da plataforma digital.
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-4">
              <Button
                disabled={!aceite}
                onClick={() => {
                  aceitarTermo();
                }}
              >
                Confirmar
              </Button>
            </div>
          </div>
        </>
      ) : (
        <LoadingIndicator />
      )}
    </div>
  );
};
